export default "__VITE_ASSET__DZv0TlIE__"